import { render, staticRenderFns } from "./RegisterLessonCustomization.vue?vue&type=template&id=0fa8b328&"
import script from "./RegisterLessonCustomization.vue?vue&type=script&lang=js&"
export * from "./RegisterLessonCustomization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports